import { render } from "./HospitalTypeTable.vue?vue&type=template&id=9abf0e48&scoped=true"
import script from "./HospitalTypeTable.vue?vue&type=script&lang=js"
export * from "./HospitalTypeTable.vue?vue&type=script&lang=js"

import "./HospitalTypeTable.vue?vue&type=style&index=0&id=9abf0e48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9abf0e48"]])

export default __exports__